"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = tslib_1.__importStar(require("react"));
var recompose_1 = require("recompose");
var contexts_1 = require("../../contexts");
var utils_1 = require("../../utils");
var hocs_1 = require("../hocs");
var styled_components_1 = require("styled-components");
var StyledBox_1 = require("./StyledBox");
var BoxInner = /** @class */ (function (_super) {
    tslib_1.__extends(BoxInner, _super);
    function BoxInner() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {};
        return _this;
    }
    BoxInner.getDerivedStateFromProps = function (nextProps, prevState) {
        // Since Box can change the background color for its contents,
        // we update the theme to indicate whether the current context is `dark`
        // and what icon theme to use.
        var background = nextProps.background, propsTheme = nextProps.theme;
        var stateTheme = prevState.theme, priorTheme = prevState.priorTheme;
        var dark = propsTheme.dark;
        if (background) {
            dark = utils_1.backgroundIsDark(background, propsTheme);
        }
        if (dark === propsTheme.dark && stateTheme) {
            return { theme: undefined, priorTheme: undefined };
        }
        if (dark !== propsTheme.dark && (!stateTheme || dark !== stateTheme.dark || propsTheme !== priorTheme)) {
            return {
                theme: tslib_1.__assign(tslib_1.__assign({}, propsTheme), { dark: dark, icon: dark ? propsTheme.iconThemes.dark : propsTheme.iconThemes.light }),
                priorTheme: propsTheme
            };
        }
        return null;
    };
    BoxInner.prototype.render = function () {
        var _a = this.props, a11yTitle = _a.a11yTitle, children = _a.children, direction = _a.direction, elevation = _a.elevation, // munged to avoid styled-components putting it in the DOM
        fill = _a.fill, // munged to avoid styled-components putting it in the DOM
        forwardRef = _a.forwardRef, gap = _a.gap, overflow = _a.overflow, // munged to avoid styled-components putting it in the DOM
        responsive = _a.responsive, tag = _a.tag, propsTheme = _a.theme, wrap = _a.wrap, // munged to avoid styled-components putting it in the DOM,
        width = _a.width, // munged to avoid styled-components putting it in the DOM
        height = _a.height, // munged to avoid styled-components putting it in the DOM
        rest = tslib_1.__rest(_a, ["a11yTitle", "children", "direction", "elevation", "fill", "forwardRef", "gap", "overflow", "responsive", "tag", "theme", "wrap", "width", "height"]); // TODO: Types
        var _b = this.state, stateTheme = _b.theme, priorTheme = _b.priorTheme;
        var theme = stateTheme || propsTheme;
        var contents = children;
        if (gap) {
            contents = [];
            var firstIndex_1;
            React.Children.forEach(children, function (child, index) {
                if (child) {
                    if (firstIndex_1 === undefined) {
                        firstIndex_1 = index;
                    }
                    else {
                        contents.push(React.createElement(StyledBox_1.StyledBoxGap, { key: index, gap: gap, directionProp: direction, responsive: responsive, theme: theme }));
                    }
                }
                contents.push(child);
            });
        }
        var content = (React.createElement(StyledBox_1.StyledBox, tslib_1.__assign({ as: tag, "aria-label": a11yTitle, ref: forwardRef, directionProp: direction, elevationProp: elevation, fillProp: fill, overflowProp: overflow, wrapProp: wrap, widthProp: width, heightProp: height, responsive: responsive, theme: theme, priorTheme: priorTheme }, rest), contents));
        if (stateTheme) {
            content = React.createElement(contexts_1.ThemeContext.Provider, { value: stateTheme }, content);
        }
        return content;
    };
    BoxInner.defaultProps = {
        direction: 'column',
        margin: 'none',
        pad: 'none',
        responsive: true,
        tag: 'div'
    };
    return BoxInner;
}(React.PureComponent));
/** @component */
exports.Box = recompose_1.compose(styled_components_1.withTheme, hocs_1.withForwardRef)(BoxInner);
//# sourceMappingURL=Box.js.map